import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import CustomToast from '../../components/toast/toast.jsx';
import API from '../../api/api.jsx';

const Settings_002_01 = ({ showModal, handleClose, feeInfoOptions, DetailData }) => {

    const { t }             = useTranslation();

    // 토스트
	const [toast, setToast] = useState(false);
	const [text, setText]   = useState('');

    // 수정여부 체크(값이 존재하는 경우는 true , 값이 null , undefinded, 빈문자열은 false )
    const isEditMode   = !!DetailData;
    const selectedData = DetailData;

    const initFeeId   = isEditMode ? selectedData.fee_id : '';       // 수수료 ID
    const initFeeName = isEditMode ? selectedData.fee_name : '';     // 수수료명
    const initFee     = isEditMode ? selectedData.fee : 0;          // 수수료
    const initSortSn  = isEditMode ? selectedData.sort_sn : 0;      // 회수처리순번

    // 수수료정보
    const initFeeType = useMemo(() => (
        showModal ? (isEditMode ? selectedData.fee_type : feeInfoOptions[0][0]) : ''
    ), [showModal, isEditMode, selectedData, feeInfoOptions]);

    // 데이터 일괄 묶기
    const [formData, setFormData] = useState({
        fee_id     : '',
        fee_name   : '',
        fee        : 0,
        fee_type   : '',
        sort_sn    : 0,
    }); 

    // 렌더링
    useEffect(() => {
        //모달창이 열리면 실행 
        if (showModal) {
            if (isEditMode) {
                setFormData({                
                    fee_id     : selectedData.fee_id,
                    fee_name   : selectedData.fee_name,
                    fee        : selectedData.fee,
                    fee_type   : selectedData.fee_type,
                    sort_sn    : selectedData.sort_sn
                });
            }else{
                setFormData({                
                    fee_id     : initFeeId,
                    fee_name   : initFeeName,
                    fee        : initFee,
                    fee_type   : initFeeType,
                    sort_sn    : initSortSn,
                });
            }
        }

    },[showModal, isEditMode, initFeeId, initFee, initFeeName, initFeeType, initSortSn, selectedData])

    // input 값 변경 액션
    const handleChange = (e) => {
        const { id, value } = e.target;

        if (id === 'fee') {
            // 정규식: 숫자 또는 소수점만 허용
            const regex = /^[0-9.]*$/;

            if (!regex.test(value)) {
                // 잘못된 형식의 입력인 경우 현재 값 그대로 유지
                setFormData((prevData) => ({ ...prevData }));
                return;
            }
        };

        if (id === 'sort_sn') {
            // 정규식: 숫자만 허용
            const regex = /^[0-9]*$/;

            if (!regex.test(value)) {
                // 잘못된 형식의 입력인 경우 현재 값 그대로 유지
                setFormData((prevData) => ({ ...prevData }));
                return;
            }
        };

        setFormData((prevData) => ({ ...prevData, [id]: value }));
    };

    // 데이터 저장시에 useRef 를 통해서 
    const formRef = useRef(null);

    // 저장 액션
    const handleSave = async (e) => {
        e.preventDefault();

        if (!formData.fee_name) {
            alert('Please enter a fee name.');
            return;
        };

        if (formData.fee === '') {
            alert('Please enter the fee.');
            return;
        };

        if (formData.sort_sn === '') {
            alert('Please enter the sort.');
            return;
        };

        try {
            const savedData = await API.fetchSettings002DataPost({ formData });

           // 등록
            if (savedData.code === 201) {
                const message = savedData.result.content.message;

                setText(t(`LOAN_APPLICATION.${message}`, { defaultValue: message }));

                setToast(true);

                return;
            }

            // 수정
            if (savedData.code === 200) {
                const message = savedData.result.content.message;

                setText(t(`COLLECTION_MANAGEMENT.${message}`, { defaultValue: message }));

                setToast(true);

                return;
            }
        } catch (error) {
            console.error('수수료 정보 저장 에러:', error);
        } finally {
            handleClose();
        }
    
        try {
            // 수동으로 폼 제출
            formRef.current.submit();
        } catch (error) {
            console.error('수동으로 폼 제출 에러:', error);
            // 폼 제출이 실패했을 때 수행할 로직을 추가하면 됩니다.
        }
    };

    return (
        <>
            <CustomToast show={toast} setToast={setToast} text={text} />
            <Modal show={showModal} onHide={handleClose} centered dialogClassName="modal-lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{t('MENU_I18N.수수료 관리', { defaultValue: '수수료 관리' })}</Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-start">
                    <div className="row gx-4">
                        <div className="col-lg-12">
                            <div className="card border-1 mb-4">
                                <div className="card-body fw-bold">
                                    {/* 폼시작  2023.11.30 추가 전종표 */}
                                    {/* ref={formRef}를 사용하여 formRef가 form 엘리먼트를 참조하도록 설정. 
                                    그리고 handleSave 함수에서는 이 formRef를 사용하여 submit 메소드를 호출 */}
                                    <form ref={formRef} onSubmit={handleSave}>
                                        <div className="form-group mb-0">
                                            <div className="form-group mb-3">
                                                <label className="form-label" htmlFor="fee_name">{t('PREFERENCES.수수료명', { defaultValue: '수수료명' })} {isEditMode ? null : <span className="text-danger">*</span>}</label>
                                                <input className="form-control" value={formData.fee_name} type="text" id="fee_name"  onChange={handleChange}  />
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="fee">{t('PREFERENCES.수수료', { defaultValue: '수수료' })}</label>
                                                <input className="form-control" value={formData.fee} type="text" id="fee" onChange={handleChange}  />
                                            </div>
                                        
                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="fee_type">{t('PREFERENCES.수수료정보', { defaultValue: '수수료정보' })}</label>
                                                <select
                                                    className="form-select"
                                                    id="fee_type"
                                                    onChange={handleChange}
                                                    value={formData.fee_type}
                                                >
                                                    {feeInfoOptions.map((option, index) => (
                                                        <option key={index} value={option[0]}>
                                                            {t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="sort_sn">{t('PREFERENCES.회수처리순번', { defaultValue: '회수처리순번' })}</label>
                                                <input className="form-control" value={formData.sort_sn} type="text" id="sort_sn"  onChange={handleChange}  />
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <div className="card-footer">
                                    <button className="btn btn-outline-success float-end mt-1 mb-1 me-1 ms-auto w-100px" onClick={handleSave}>{t('COLLECTION_MANAGEMENT.저장', { defaultValue: '저장' })} <i className="fa fa-sign-in"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="d-block">
                    <button className="btn btn-outline-gray me-1 mb-1 w-100px" onClick={handleClose}>
                        <i className="fa fa-backward"></i> {t('COLLECTION_MANAGEMENT.취소', { defaultValue: '취소' })}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Settings_002_01;